import { getParameters } from '../../../helpers/helpers';
import { USER_FORM } from './form-portaluser-type';

import HandleExistingPortalUser from './displayPortalUser/get-existing-portal-user';
import CreatePortalUser from './createPortalUser/create-portal-user';
import UpdatePortalUser from './update-portal-user';
import HandlePasswordReset from './displayPortalUser/handle-password-reset';

/**
 * Function handles routing for the portal users form based on the parameter createUser
 */
export const formPortalUser = () => {
  if ( !USER_FORM.userFormContainer ) return;

  const formAction = getParameters('createUser');
  const userID = getParameters('userID'); 

  if ( formAction === 'true' ) {
    CreatePortalUser();
  } else {
    HandleExistingPortalUser();
    HandlePasswordReset(userID);
    UpdatePortalUser();
  }
}